exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-card[data-v-334de5bc] {\n\tmin-height: 150px;\n\tcursor: pointer;\n}\n.bg-success[data-v-334de5bc] {\n\tbackground-color: #fdf9f6;\n}\n.text-white[data-v-334de5bc] {\n\tcolor: white\n}\n\n", ""]);

// exports
